import { render, staticRenderFns } from "./AppTel.vue?vue&type=template&id=0d2be354&scoped=true"
import script from "./AppTel.vue?vue&type=script&lang=js"
export * from "./AppTel.vue?vue&type=script&lang=js"
import style0 from "./AppTel.vue?vue&type=style&index=0&id=0d2be354&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2be354",
  null
  
)

export default component.exports